export default {"src":"/_next/static/media/tnb.0d2e2e44.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};